export const storeAudience = (audience: Array<any>) => ({
    type: 'STORE_AUDIENCE',
    audience
});